<form [formGroup]="form" autocomplete="off">
  <section class="px-3" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
    <mat-icon class="scan-icon" tabindex="2" svgIcon="qrcode-scan" (click)="focusOnDriver()"></mat-icon>
    <mat-form-field fxFlex="50" appearance="legacy">
      <mat-label>{{ 'project:add-drivers.scan-driver' | i18nextCap }}</mat-label>
      <input tabindex="1" #driverInput matInput formControlName="driver" (blur)="this.form.get('driver').value && submit$.next(null)" />
    </mat-form-field>
  </section>
</form>
